import React from 'react';
import './LegalPage.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <h1>POLÍTICA DE PRIVACIDAD</h1>

      <section>
        <h2>1. Identidad del Responsable</h2>
        <p>
          Responsable: CloserAcademy<br />
          Razón Social: DMG BSNS SLU<br />
          NRT: L-719268-A<br />
          Domicilio: Avinguda Príncep Benlloch, 26-30, Edifici Clara Rabassa, Taula C39 AD500 Andorra la Vella <br />
          Correo electrónico: ceocloseracademy@gmail.com<br />
          Sitio Web: <a href="https://landing.closeracademy.app" target="_blank" rel="noopener noreferrer">https://landing.closeracademy.app</a>
        </p>
      </section>

      <section>
        <h2>2. Legislación aplicable</h2>
        <p>
          Esta Política de Privacidad se ajusta a lo establecido en la Llei 29/2021, Qualificada de Protecció de Dades Personals del Principat d'Andorra, así como al Reglamento (UE) 2016/679 (RGPD) en cuanto a usuarios que accedan desde el Espacio Económico Europeo.
        </p>
      </section>

      <section>
        <h2>3. Principios aplicados en el tratamiento de datos</h2>
        <ul>
          <li>Licitud, lealtad y transparencia: se requerirá siempre el consentimiento explícito.</li>
          <li>Minimización de datos: solo se solicitan los datos estrictamente necesarios.</li>
          <li>Limitación del plazo de conservación: los datos se conservarán únicamente el tiempo necesario.</li>
          <li>Integridad y confidencialidad: se adoptan medidas de seguridad adecuadas.</li>
        </ul>
      </section>

      <section>
        <h2>4. Obtención de datos personales</h2>
        <p>
          Para navegar por el sitio web no es necesario facilitar datos personales. Los datos solo se recopilan cuando el Usuario envía un formulario, se suscribe, realiza una compra o se comunica con el Titular.
        </p>
      </section>

      <section>
        <h2>5. Finalidad del tratamiento</h2>
        <p>Los datos personales pueden utilizarse para:</p>
        <ul>
          <li>Enviar comunicaciones.</li>
          <li>Gestionar compras y acceso a productos.</li>
          <li>Analizar el comportamiento de navegación (cookies).</li>
          <li>Cumplir con obligaciones legales.</li>
        </ul>
        <p>
          Base legal: el consentimiento del Usuario, la ejecución de un contrato, el cumplimiento de obligaciones legales y el interés legítimo del Titular.
        </p>
      </section>

      <section>
        <h2>6. Derecho de desistimiento y política de devoluciones </h2>
        <p>
        De acuerdo con la normativa aplicable, el Usuario dispone de un plazo máximo de 14 días 
naturales desde la fecha de contratación para solicitar la devolución del importe abonado. 
Este derecho solo será aplicable siempre y cuando el Usuario no haya utilizado de ningún 
modo el contenido digital del producto. 
A efectos legales, se entenderá que el Usuario ha utilizado el contenido digital cuando haya 
realizado cualquiera de las siguientes acciones: 
● Haya entrado en la plataforma de formación y haya interactuado con ella. 
● Haya abierto o reproducido, total o parcialmente, alguno de los vídeos grabados. 
● Haya asistido o se haya conectado a una clase en directo. 
● Haya descargado, abierto o consultado material complementario (guías, PDFs, 
plantillas, etc.). 
● Haya consultado cualquier recurso, documento o contenido incluido dentro de la 
formación. 
● O haya realizado cualquier acción que implique consumo, visualización o uso del 
contenido digital. 
Una vez se haya producido cualquiera de estas acciones —equivalentes a la apertura de un 
paquete físico en el comercio tradicional—, el derecho de desistimiento quedará 
automáticamente anulado, y no se admitirán devoluciones, salvo que la oferta comercial 
indique expresamente lo contrario. 
El impago de cuotas no exime del cumplimiento íntegro del importe pactado.
        </p>
      </section>

      <section>
        <h2>7. Conservación de los datos</h2>
        <p>
          Los datos se conservarán durante el tiempo estrictamente necesario para cumplir la finalidad para la que fueron recogidos y mientras se mantenga la relación contractual o legal, o hasta que el Usuario solicite su supresión.
        </p>
      </section>

      <section>
        <h2>8. Cesión de datos a terceros</h2>
        <p>
          Los datos del Usuario no serán cedidos a terceros salvo obligación legal o cuando sea necesario para prestar un servicio:
        </p>
        <ul>
          <li>
            <strong>SeQura Worldwide S.A.:</strong> cuando el Usuario elige pago aplazado, sus datos son compartidos para gestionar la financiación. 
            <a href="https://www.sequra.com/es/politica-de-privacidad" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
          </li>
          <li>
            <strong>Hotmart B.V.:</strong> plataforma encargada de gestionar el acceso a productos. 
            <a href="https://www.hotmart.com/es/pp" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
          </li>
        </ul>
        <p>
          Estas entidades actúan como encargados del tratamiento y garantizan el cumplimiento de la normativa de protección de datos.
        </p>
      </section>

      <section>
        <h2>9. Derechos del Usuario</h2>
        <p>El Usuario tiene derecho a:</p>
        <ul>
          <li>Acceder a sus datos.</li>
          <li>Solicitar la rectificación o supresión.</li>
          <li>Limitar u oponerse al tratamiento.</li>
          <li>Portar sus datos a otro responsable.</li>
        </ul>
        <p>
          Puede ejercer estos derechos enviando un email con copia del documento identificativo a: <a href="mailto:ceocloseracademy@gmail.com">ceocloseracademy@gmail.com</a>
        </p>
      </section>

      <section>
        <h2>10. Limitación de responsabilidad </h2>
        <p>
        Todos los materiales ofrecidos, tanto contenido teórico grabado como las clases en directo, se 
proporcionan “tal cual” y “según disponibilidad”. 
Esto significa que: 
● El acceso al contenido teórico grabado puede actualizarse, modificarse o reorganizarse 
en función de mejoras formativas o necesidades operativas. 
● Las clases en directo pueden variar en horarios, formato, duración o disponibilidad por 
motivos organizativos, técnicos o de agenda, sin que ello implique incumplimiento por 
parte del titular. 
● El progreso y los resultados del alumno dependen exclusivamente de su compromiso, 
participación, ejecución y circunstancias personales, por lo que no se garantiza la 
obtención de resultados específicos. 
DMG BSNS SLU no será responsable de daños directos o indirectos, pérdidas económicas, 
falta de resultados, interrupciones del servicio o cualquier consecuencia derivada del uso o no 
uso de la formación. (APDA): 
          <a href="https://www.apda.ad" target="_blank" rel="noopener noreferrer">https://www.apda.ad</a>
        </p>
      </section>

      <section>
        <h2>11. Seguridad de los datos personales</h2>
        <p>
          El Titular aplica medidas técnicas y organizativas adecuadas para garantizar la seguridad, integridad y confidencialidad de los datos personales.
        </p>
      </section>

      <section>
        <h2>12. Aceptación de condiciones </h2>
        <p>
        Antes de completar el proceso de compra, el Usuario debe aceptar de forma expresa, 
consciente e informada estos Términos y Condiciones, así como la Política de Privacidad, el 
Aviso Legal y la Política de Cookies, mediante la marcación de la casilla correspondiente 
habilitada al efecto. 
La contratación solo podrá completarse si el Usuario confirma haber leído, comprendido y 
aceptado dichas condiciones, reconociendo que constituyen el acuerdo legal que regula la 
relación entre ambas partes.
</p>
      </section>

      <section>
        <h2>13. Cambios en la Política de Privacidad</h2>
        <p>
          El Titular se reserva el derecho de modificar la presente política para adaptarla a cambios legislativos o jurisprudenciales. Las modificaciones estarán vigentes desde su publicación en el sitio web.
        </p>
        <p>Asimismo, el ALUMNO, autoriza expresamente a la EMPRESA a que los datos
personales facilitados sean remitidos a terceras empresas, con la sola finalidad de ser
estudiados y en su caso incorporados a sus bases de datos a fin de ser contratados para
la realización de servicios en cumplimiento de las condiciones de la EMPRESA.
Estos datos personales serán tratados con la máxima diligencia y serán utilizados sólo en
la medida en que sean requeridos por terceras empresas contratantes, sin que puedan
utilizarse más que los estrictamente necesarios.
El alumno, podrá negarse a este tratamiento de forma expresa.</p>
      </section>
    </div>
  );
};

export default Privacy;
